import Vue from 'vue'
import 'normalize.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss'
import "tailwindcss/tailwind.css"

import App from '@/App.vue'
import store from '@/store'
import router from '@/router'
import '@/components/_globals.js'
import dialogForm from '@/components/dialog-form'

import request from '@/utils/request'
import _ from 'lodash'

import VueMarkdownEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
import Prism from 'prismjs';

VueMarkdownEditor.use(vuepressTheme, {
  Prism,
});

Vue.use(ElementUI, {
  size: 'small',
})

Vue.use(VueMarkdownEditor);

// 定义一个名为 'humanSize' 的全局过滤器
Vue.filter('humanSize', function (bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';
  if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return 'N/A';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  // 注意：Vue 过滤器中的 `this` 不指向 Vue 实例
  // 您提供的 Intl.NumberFormat 在这里是完全可以工作的
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
});

Vue.prototype.$_ = _
Vue.prototype.$request = request
Vue.prototype.$dialogForm = dialogForm

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
})
